import { t } from 'i18next';

export const hoursGroupsTabs = {
  defaultSchedule: {
    key: 'defaultSchedule',
    label: t('scheduling.defaultSchedule'),
  },
  tradingTimes: {
    key: 'tradingTimes',
    label: t('locations.trading.tradingTimes'),
  },
  nonTradingDates: {
    key: 'nonTradingDates',
    label: t('locations.trading.nonTradingDates'),
  },
  dropOffs: {
    key: 'dropOffs',
    label: t('scheduling.slots.dropOffs'),
  },
};
